export default class ListArticlesController {
  constructor(ContentService, isMobile) {
    this.service = ContentService;
    this.isMobile = isMobile;
  }

  $onInit() {
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.subscriptions.push(
      this.articlesObservable.subscribe(
        (articles) => this.articles = articles,
        (error) => console.log(error)
      )
    );
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}

 ListArticlesController.$inject = ['ContentService', 'isMobile'];


// WEBPACK FOOTER //
// ./src/app/pages/list-articles/list-articles.controller.js